import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#2C1810] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <img
              src="https://teslacustomwinerytours.com/wp-content/uploads/2023/05/tesla-custom-winery-tours-logo.png"
              alt="Tesla Custom Winery Tours"
              className="h-20 w-20 object-contain mb-4"
            />
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              Oregon's premier luxury winery tour company, offering sustainable Tesla-powered experiences in the Willamette Valley.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="https://www.facebook.com/teslacustomwinerytours/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#8B2635] transition-all duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com/teslacustomwinerytours/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#8B2635] transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#D4AF37] transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/tours" className="text-gray-300 hover:text-[#D4AF37] transition-colors text-sm">
                  Tours
                </Link>
              </li>
              <li>
                <Link to="/experiences" className="text-gray-300 hover:text-[#D4AF37] transition-colors text-sm">
                  Experiences
                </Link>
              </li>
              <li>
                <Link to="/testimonials" className="text-gray-300 hover:text-[#D4AF37] transition-colors text-sm">
                  Testimonials
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-[#D4AF37] transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="text-lg font-bold mb-4">Service Areas</h4>
            <ul className="space-y-3">
              <li className="text-gray-300 text-sm">Portland, Oregon</li>
              <li className="text-gray-300 text-sm">Newberg, Oregon</li>
              <li className="text-gray-300 text-sm">Dundee, Oregon</li>
              <li className="text-gray-300 text-sm">McMinnville, Oregon</li>
              <li className="text-gray-300 text-sm">Salem, Oregon</li>
              <li className="text-gray-300 text-sm">Willamette Valley</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-phone-line text-[#D4AF37] text-lg mr-3 flex-shrink-0 mt-0.5"></i>
                <div>
                  <p className="text-xs text-gray-400 mb-1">Call Roger</p>
                  <a href="tel:5412601222" className="text-white hover:text-[#D4AF37] transition-colors font-semibold">
                    (541) 260-1222
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-[#D4AF37] text-lg mr-3 flex-shrink-0 mt-0.5"></i>
                <div>
                  <p className="text-xs text-gray-400 mb-1">Email</p>
                  <a href="mailto:roger@teslacustomwinerytours.com" className="text-white hover:text-[#D4AF37] transition-colors text-sm break-all">
                    roger@teslacustomwinerytours.com
                  </a>
                </div>
              </li>
            </ul>
            <a
              href="#booking"
              className="mt-6 inline-block px-6 py-2.5 bg-[#8B2635] text-white text-sm font-semibold rounded-full hover:bg-[#6B1E28] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Book Your Tour
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm">
              © 2026 Tesla Custom Winery Tours. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#D4AF37] text-sm transition-colors"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
